import { qrmInstance } from '.'
import { QRMpostPathes } from '../ApiPOSTPathes'
import { CloudOrdersPostPathes } from '../ApiGETPathes'
import { getUserData } from 'featureSliced/shared/utils/getUserData'
import { handleLocalStorage } from 'featureSliced/shared/utils/handleLocalStorage'

import { ProductToPay } from 'sections/Payment/types'
import { IProductsToOrder } from 'sections/Order/types'
import {
  AdyenPaymentInitType,
  DatatransPaymentInitType,
  IPaymentComplete,
  NotificationUser,
  SaferPayPaymentInitType,
} from './types'

const withToken = true
export class qrMenuPOST {
  private static withToken = true
  public static async bookProducts(
    table: string,
    productsToOrder: IProductsToOrder[],
    orderGuid = '',
    replaceWithMWItems = false
  ) {
    const { guid, registerId, dataEnc } = handleLocalStorage([
      'guid',
      'registerId',
      'dataEnc',
    ])
    const currentUserInfo = await getUserData()
    const res: any = await qrmInstance.post(
      QRMpostPathes.ORDER_PRODUCTS,
      {
        company: guid,
        data: dataEnc,
        register: registerId,
        table,
        orderItems: productsToOrder,
        replaceWithMWItems,
        orderGuid,
        cardId:
          JSON.parse(
            currentUserInfo?.attributes?.['custom:card_collection'] || 0
          )?.[guid?.toLowerCase()] || 0,
      },
      withToken
    )
    return res
  }

  public static async paymentRequest(
    isBeforeMeal: boolean,
    tipsPercentage: number,
    table: string | null,
    useSavedCard: boolean,
    useCustomerCard: boolean,
    updateActiveCard: boolean,
    choosenProducts: ProductToPay[] | any,
    shopId?: string, // for HS-Pay only
    hsPaymentData?: any // for HS-Pay only
  ): Promise<
    SaferPayPaymentInitType | DatatransPaymentInitType | AdyenPaymentInitType
  > {
    const { guid, dataEnc, registerId, selfServiceName, selfServicePhone } =
      handleLocalStorage([
        'guid',
        'dataEnc',
        'registerId',
        'selfServiceName',
        'selfServicePhone',
      ])
    let params: any = {
      company: guid,
      data: dataEnc,
      register: registerId,

      table: table ? +table : 0,
      useSavedCard,
      useCustomerCard,
      updateActiveCard,
      tipsPercetage: tipsPercentage,
      shopId: shopId || null,
      hsPaymentData: hsPaymentData || {},
    }
    if (isBeforeMeal) {
      params = {
        ...params,
        orderItems: choosenProducts,
        // total: getTotalPrice(choosenProducts),
      }
    }
    if (!isBeforeMeal) {
      params = {
        ...params,
        choosenProducts: choosenProducts,
      }
    }
    const currentUserInfo = await getUserData()
    const sessionId = handleLocalStorage('sessionId')

    const res: SaferPayPaymentInitType | AdyenPaymentInitType =
      await qrmInstance.post(
        QRMpostPathes.CREATE_PAYMENT,
        {
          ...params,
          ...(selfServiceName || selfServicePhone
            ? {
                customerInfo: {
                  name: selfServiceName || '',
                  phoneNumber: selfServicePhone || '',
                  sessionId,
                  userId: currentUserInfo.sub,
                },
              }
            : {}),
        },
        withToken
      )
    return res
  }

  public static async paymentComplete(
    paymentVariant: 1 | 2 | 3,
    transactionId: string | null,
    orderGuid: string | null,
    redirectResult?: string | null
  ) {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res: IPaymentComplete = await qrmInstance.post(
      QRMpostPathes.COMPLETE_PAYMENT,
      {
        company: guid,
        data: dataEnc,
        transactionId,
        redirectResult,
        orderGuid,
        beforeMeal: paymentVariant === 1,
      },
      withToken
    )
    return res
  }

  public static async addNotificationUser(
    token: string,
    customerName: string | null = null,
    phoneNumber: string | null = null
  ): Promise<NotificationUser | null> {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    let res: NotificationUser | null = null
    if (customerName && phoneNumber) {
      res = await qrmInstance.post(QRMpostPathes.ADD_NOTIFICATION_USER, {
        company: guid?.toLowerCase(),
        data: dataEnc,
        deviceToken: token,
        customerName,
        phoneNumber,
      })
    }
    return res
  }

  public static async sendReseipt(
    email: string,
    paymentId: string | null,
    orderGuid: string | null
  ): Promise<any> {
    const res: IPaymentComplete = await qrmInstance.post(
      QRMpostPathes.SEND_RECEIPT,
      {
        email,
        paymentId,
        orderGuid,
      },
      withToken
    )
    return res
  }

  public static async createNewPaymentVariant(
    shopId: string | null = null,
    hsPaymentData: any = null
  ): Promise<any> {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res: any = await qrmInstance.post(
      QRMpostPathes.CREATE_PAYMENT_VARIANT,
      {
        company: guid,
        data: dataEnc,
        hsPaymentData,
        shopId,
      },
      withToken
    )
    return res
  }

  public static async completeNewPaymentVariant(
    transactionId: string
  ): Promise<any> {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res: any = await qrmInstance.post(
      QRMpostPathes.CONFIRM_PAYMENT_VARIANT,
      {
        transactionId,
        company: guid,
        data: dataEnc,
      },
      withToken
    )
    return res
  }

  public static async callWaiter(table: number) {
    const { guid, registerId, dataEnc } = handleLocalStorage([
      'guid',
      'registerId',
      'dataEnc',
    ])

    const res: any = await qrmInstance.post(
      QRMpostPathes.CALL_WAITER,
      {
        company: guid,
        register: registerId,
        data: dataEnc,
        table,
      },
      withToken
    )
    return res
  }

  public static async updateCloudOrders(
    table: string | null,
    orderItems?: IProductsToOrder[],
    orderGuid?: string
  ) {
    const { guid, registerId, dataEnc } = handleLocalStorage([
      'guid',
      'registerId',
      'dataEnc',
    ])
    const res: any = await qrmInstance.post(
      CloudOrdersPostPathes.UPDATE_ORDERS,
      {
        table,
        orderItems,
        register: registerId,
        data: dataEnc,
        orderGuid,
        company: guid,
      }
    )
    return res
  }

  public static async closeCloudOrders(orderGuid: string, table: number) {
    const { guid, registerId, dataEnc } = handleLocalStorage([
      'guid',
      'registerId',
      'dataEnc',
    ])
    const res: any = await qrmInstance.post(CloudOrdersPostPathes.CLOSE_ORDER, {
      orderGuid,
      register: registerId,
      data: dataEnc,
      company: guid,
      table,
    })
    return res
  }
}
